var metodBankMenuButton = {
    init: function () {
        document.addEventListener('click', function (e) {
            // Check if the clicked element is a menu button
            if (e.target && e.target.matches('[id^="megamenuButton"]')) {
                var menuClass = e.target.getAttribute('data-menu-target');
                var menuToToggle = document.querySelector('.dropdownmenu.' + menuClass);

                // Determine if the clicked menu is already open
                var isMenuAlreadyOpen = menuToToggle && menuToToggle.classList.contains('show');

                // First, close all menus
                var allDropdowns = document.querySelectorAll('.dropdownmenu');
                allDropdowns.forEach(function (dropdown) {
                    dropdown.classList.remove('show');
                });

                // Then, if the menu was not already open, open it
                if (menuToToggle && !isMenuAlreadyOpen) {
                    menuToToggle.classList.add('show');
                }
            }
            else if (e.target && e.target.classList.contains('collapseButton')) {
                // Find the closest ancestor that's a container block, then find the collapsibleContent within it
                var containerBlock = e.target.closest('.container-block');
                var collapsibleContent = containerBlock.querySelector('.collapsibleContent');

                // Toggle visibility
                if (collapsibleContent) {

                    // Use getComputedStyle to check the current display state
                    var style = window.getComputedStyle(collapsibleContent);
                    var isCurrentlyHidden = style.display === 'none';

                    // Toggle visibility based on computed style
                    collapsibleContent.style.display = isCurrentlyHidden ? 'block' : 'none';

                    // Toggle "open" class on the button
                    e.target.classList.toggle('open', isCurrentlyHidden);

                    //var isCurrentlyHidden = collapsibleContent.style.display === 'none';
                    //collapsibleContent.style.display = isCurrentlyHidden ? 'block' : 'none';

                    //collapsibleContent.style.display = collapsibleContent.style.display === 'block' ? 'none' : 'block';

                    // Toggle "open" class on the button based on content visibility
                    //if (isCurrentlyHidden) {
                    //    e.target.classList.add('open');
                    //} else {
                    //    e.target.classList.remove('open');
                    //}
                }
            }

        });
    }
};

metodBankMenuButton.init();

metodbanknav = function () {

    var openMethodNav = function openMethodNav(e) {
        e.preventDefault();
        $('#metodbanknav').slideToggle();
        $(this).blur();
        $('body').toggleClass('metodbanknav');
        $('.nav-toggle').toggleClass('metodbanknav-expanded');

        if ($('.nav-toggle > span').html() === "Meny") {
            $('.nav-toggle > span').html("Stäng meny");
        } else {
            $('.nav-toggle > span').html("Meny");
        }
    };

    var closeSideBar = function closeSideBar(e) {
        e.preventDefault();
        $('body').removeClass('metodbanknav');
        $('#metodbanknav').hide();
        $('.nav-toggle').removeClass('metodbanknav-expanded'); ////When metodbanknav animation complete, hide the metodbanknav.

        if (history.pushState) {
            var cleanuri = location.protocol + "//" + location.host + location.pathname;
            window.history.replaceState({}, document.title, cleanuri);
        }
    };

    var registerEvents = function registerEvents() {
        $('.nav-toggle').click(openMethodNav);
        $('.search-toggle').click(function () {
            $('#headersearch').fadeToggle();
            $('.header-area').toggleClass('open');
            $('#metodbanknav').toggleClass('open');
        });
        $('.nav-toggle').click(function () {
            $('#nav-icon4').toggleClass('open');
        });
        $('#metodbanknav ul a').click(function (e) {
            e.preventDefault();
            var parser = document.createElement('a');
            parser.href = $(this).attr('href');
            var uri = parser.pathname;

            if (uri.charAt(0) != "/") {
                uri = "/" + uri;
            }

            window.location.href = uri + '?nav=true';
        });

        $('#metodbanknav a').blur(function (e) {
            setTimeout(function () {
                if ($(document.activeElement).closest('#metodbanknav').length == 0) {
                    closeSideBar(e);
                }
            }, 1);
        });
    };

    var iScrollPos = 0;

    var scrollSideBar = function scrollSideBar(e) {
        e.preventDefault();
        var iCurScrollPos = $(this).scrollTop();

        if (iCurScrollPos > iScrollPos) {
            console.log("scrolling dowm");
            $('#metodbanknav').slideUp();
            $('.nav-toggle').removeClass('metodbanknav-expanded');
        } else {
            $('#metodbanknav').slideDown();
            $('.nav-toggle').addClass('metodbanknav-expanded');

            console.log("scrolling up");
        }

        iScrollPos = iCurScrollPos;
    };

    var init = function init() {
        $(document).ready(function () {
            $('#metodbanknav').removeClass('metodbanknav-init');
        });

        if (!$('body').hasClass('metodbanknav')) {
            $('#metodbanknav').hide();
        }

        registerEvents();
    };

    return {
        init: init,
        open: openMethodNav
    };
}();